import React from "react"
import SEO from "../components/SEO"

const ShippingPolicy: React.FC = () => {
  return (
    <>
      <SEO
        title="Shipping & Delivery Policy"
        description="Read Thecodebazaar.com's shipping and delivery policy for digital products and services."
      />

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold text-gray-900 text-center">
            Shipping & Delivery Policy
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm">
          <p className="text-gray-600 mb-8">
            Last updated: January 2025
          </p>

          <div className="prose max-w-none space-y-8">
            {/* 1 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                1. Nature of Products
              </h2>
              <p className="text-gray-700">
                Thecodebazaar.com primarily sells <strong>digital products</strong>
                including website themes, templates, source code, UI components,
                courses, and other downloadable resources. We do not ship any
                physical goods.
              </p>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                2. Delivery Method
              </h2>
              <p className="text-gray-700">
                Once payment is successfully completed, digital products are
                delivered using one or more of the following methods:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>Instant download link on the website</li>
                <li>Delivery via email to the registered email address</li>
                <li>Delivery via WhatsApp on the provided WhatsApp number</li>
              </ul>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                3. Delivery Timeline
              </h2>
              <p className="text-gray-700">
                In most cases, digital products are delivered <strong>immediately</strong>
                after successful payment. However, delivery timelines may vary
                depending on the product type and delivery method.
              </p>
              <p className="text-gray-700 mt-3">
                If for any reason the product is not delivered immediately,
                customers are requested to contact us.
              </p>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                4. Non-Delivery or Delay
              </h2>
              <p className="text-gray-700">
                If payment is successful but the product is not received, please
                contact us with your payment details and order information.
              </p>
              <p className="text-gray-700 mt-3">
                In such cases, we guarantee delivery of the purchased product
                within <strong>3 business days</strong> after verification.
              </p>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. Incorrect Contact Information
              </h2>
              <p className="text-gray-700">
                Customers are responsible for providing correct email addresses
                and WhatsApp numbers during checkout. Thecodebazaar.com will not
                be responsible for delivery failures caused by incorrect or
                incomplete contact details.
              </p>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                6. International Delivery
              </h2>
              <p className="text-gray-700">
                As all products are digital, delivery is available worldwide.
                There are no shipping charges, customs duties, or geographical
                restrictions.
              </p>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                7. Service-Based Delivery
              </h2>
              <p className="text-gray-700">
                For services such as website development or customization,
                delivery timelines will be communicated separately based on the
                project scope and agreement.
              </p>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                8. Contact & Support
              </h2>
              <p className="text-gray-700">
                For any delivery-related issues, customers may contact us
                through the official support channels available on
                Thecodebazaar.com. We aim to respond and resolve issues promptly.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                9. Policy Updates
              </h2>
              <p className="text-gray-700">
                Thecodebazaar.com reserves the right to update or modify this
                Shipping & Delivery Policy at any time without prior notice.
                Changes will be effective immediately upon posting on the
                website.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

export default ShippingPolicy
